import { platforms } from 'enums/app';

export default {
  _authError: null,
  appId: null,
  cdn: null,
  chatClientConnectionStatus: null,
  isNavigating: false,
  clientReady: false,
  deviceId: null,
  deviceManufacturer: null,
  deviceModel: null,
  estimatedWait: 0, // unit is is in seconds
  // flag indicating that the app is ready to display (configuration fetched, login done etc)
  initialized: false,
  loginDomain: null,
  orgDomain: null,
  orgId: null,
  os: null,
  osVersion: null,
  platform: platforms.WEB,
  proactiveTriggered: false,
  ready: false,
  secureOrgId: null,
  sdkVersion: null,
  _serverError: null,
  vaultId: null,
};
